export default __webpack_public_path__ + "static/media/jamon.5891d4ce.jpeg";